<template>

    <div>
        <div class="header-wrapper" id="home">
            <section class="hero is-fullheight">
<!--                <nav class="navbar is-transparent is-hidden-desktop">-->
<!--                    <div class="navbar-brand">-->
<!--                        <div class="navbar-burger burger" data-target="mobile-nav">-->
<!--                            <span></span>-->
<!--                            <span></span>-->
<!--                            <span></span>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div id="mobile-nav" class="navbar-menu">-->
<!--                        <div class="navbar-end">-->
<!--                            <div class="navbar-item">-->
<!--                                <a class="navbar-item" href="#home">-->
<!--                                    Home-->
<!--                                </a>-->
<!--                            </div>-->
<!--                            <div class="navbar-item">-->
<!--                                <a class="navbar-item" href="#about-me">-->
<!--                                    About Me-->
<!--                                </a>-->
<!--                            </div>-->
<!--                            <div class="navbar-item">-->
<!--                                <a class="navbar-item" href="#services">-->
<!--                                    Services-->
<!--                                </a>-->
<!--                            </div>-->
<!--                            <div class="navbar-item">-->
<!--                                <a class="navbar-item" href="#skills">-->
<!--                                    Skills-->
<!--                                </a>-->
<!--                            </div>-->
<!--                            <div class="navbar-item">-->
<!--                                <a class="navbar-item" href="#my-work">-->
<!--                                    My Work-->
<!--                                </a>-->
<!--                            </div>-->
<!--                            <div class="navbar-item">-->
<!--                                <a class="navbar-item" href="#contact">-->
<!--                                    Contact-->
<!--                                </a>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </nav>-->

                <div class="hero-body" data-aos="fade">
                    <div class="container has-text-centered">
                        <h3 class="subtitle">Hey, I'm</h3>
                        <h2 class="title">Paul</h2>
                        <h1 class="subtitle is-4">Software Engineer, Entrepreneur, E-Business Student
                        </h1>
                    </div>
                </div>


<!--                <div class="hero-foot ">-->
<!--                    <div class="hero-foot&#45;&#45;wrapper">-->
<!--                        <div class="columns">-->
<!--                            <div class="column is-12 hero-menu-desktop has-text-centered">-->
<!--                                <ul>-->
<!--                                    <li class="is-active">-->
<!--                                        <a href="#home">Home</a>-->
<!--                                    </li>-->
<!--                                    <li>-->
<!--                                        <a href="#about-me">About Me</a>-->
<!--                                    </li>-->
<!--                                    <li>-->
<!--                                        <a href="#services">Services</a>-->
<!--                                    </li>-->
<!--                                    <li>-->
<!--                                        <a href="#skills">Skills</a>-->
<!--                                    </li>-->
<!--                                    <li>-->
<!--                                        <a href="#my-work">My Work</a>-->
<!--                                    </li>-->
<!--                                    <li>-->
<!--                                        <a href="#contact">Contact</a>-->
<!--                                    </li>-->
<!--                                </ul>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
                <!-- End Hero Menu -->
            </section>
        </div>

        <div class="main-content">

            <about-me></about-me>
<!--            <quote></quote>-->
            <skills></skills>
            <projects></projects>
            <get-in-touch></get-in-touch>

        </div>

        <footer class="footer">
            <div class="content has-text-centered">
                <p>
                    © Paul Zimmermann, 2020
                </p>
            </div>
        </footer>
    </div>
</template>

<script>
import AboutMe from "./AboutMe";
import Quote from "./Quote";
import Services from "./Services";
import Skills from "./Skills";
import GetInTouch from "./GetInTouch";
import Projects from "./Projects";
export default {
    name: "parallax",
    components: {Projects, GetInTouch, Skills, Services, Quote, AboutMe}
}
</script>

<style lang="scss">
@import '../../src/assets/showcase.css';


 .subtitle > a {
     /*text-decoration: none;*/
     color: white;
 }
    /*@import './assets/styles/yourstyles.css';*/


.right-left {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;

    margin-bottom: 5rem;
}

#quote {
    font-size: 20px;
    font-family: 'Lato', sans-serif !important;
    font-style: italic;
}

</style>
